module.exports = __webpack_public_path__ + "img/avatar-34.ca09ba62.png";